export default __webpack_public_path__ + "media/zurb/img/lab/thumbnails/patterntap/type-c66bf9cfc4df713035c864afcde0a68f.png";